import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isU8a, u8aToHex } from '@polkadot/util';
/**
 * @name bool
 * @description
 * Representation for a boolean value in the system. It extends the base JS `Boolean` class
 * @noInheritDoc
 */

export var bool = /*#__PURE__*/function (_Boolean) {
  _inherits(bool, _Boolean);

  var _super = _createSuper(bool);

  function bool(registry) {
    var _this;

    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, bool);

    _this = _super.call(this, isU8a(value) ? value[0] === 1 : value instanceof Boolean ? value.valueOf() : !!value);
    _this.registry = registry;
    return _this;
  }
  /**
   * @description The length of the value when encoded as a Uint8Array
   */


  _createClass(bool, [{
    key: "encodedLength",
    get: function get() {
      return 1;
    }
    /**
     * @description returns a hash of the contents
     */

  }, {
    key: "hash",
    get: function get() {
      return this.registry.hash(this.toU8a());
    }
    /**
     * @description Checks if the value is an empty value (true when it wraps false/default)
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.isFalse;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */

  }, {
    key: "isFalse",
    get: function get() {
      return !this.isTrue;
    }
    /**
     * @description Checks if the value is an empty value (always false)
     */

  }, {
    key: "isTrue",
    get: function get() {
      return this.valueOf();
    }
    /**
     * @description Compares the value of the input to see if there is a match
     */

  }, {
    key: "eq",
    value: function eq(other) {
      return this.valueOf() === (other instanceof Boolean ? other.valueOf() : other);
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return {
        outer: [this.toU8a()]
      };
    }
    /**
     * @description Returns a hex string representation of the value
     */

  }, {
    key: "toHex",
    value: function toHex() {
      return u8aToHex(this.toU8a());
    }
    /**
     * @description Converts the Object to to a human-friendly JSON, with additional fields, expansion and formatting of information
     */

  }, {
    key: "toHuman",
    value: function toHuman() {
      return this.toJSON();
    }
    /**
     * @description Converts the Object to JSON, typically used for RPC transfers
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.valueOf();
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'bool';
    }
    /**
     * @description Returns the string representation of the value
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.toJSON().toString();
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      return new Uint8Array([this.valueOf() ? 1 : 0]);
    }
  }]);

  return bool;
}( /*#__PURE__*/_wrapNativeSuper(Boolean));